export default __webpack_public_path__ + "static/media/x-octagon.16d5456e.svg";